import * as Yup from "yup";
import yupValidateInternationalPhoneNumber from "../../../../../utils/helpers/yupValidateInternationalPhoneNumber";
import { tt } from "../../../../../utils/i18n/i18n";

const delivery_info_validation_schema = Yup.object({
  shippingAddress: Yup.object({
    phoneNumber: Yup.string()
      .required(tt("phone_required"))
      .test(
        "is-valid-phone",
        tt("validPhoneNumberMessage"),
        function (value, { createError }) {
          return yupValidateInternationalPhoneNumber(
            "shippingAddress.phoneNumber",
            value,
            createError
          );
        }
      )
  })
});

export { delivery_info_validation_schema };
